import clsx from "clsx"
import { dotsloader, spinner, pulse } from "./theme"
import { useI18n as useTranslation } from "@/hooks"

export const LoadingOverlay = ({
	children,
	className,
	text = "Chargement du contenu ...",
	minHeight = "auto",
	background = "rgba(0, 0, 0, 0.05)",
	spinner,
	loader,
	pulse,
	active = true,
	...rest
}) => {
	const { t } = useTranslation()

	return (
		<div
			className={clsx("relative z-[10]", className)}
			style={{ minHeight }}
			{...rest}
		>
			{children}
			{active ? (
				<div
					className="absolute inset-0 flex flex-col items-center justify-center gap-2"
					style={{ background }}
					aria-busy="true"
					aria-live="polite"
				>
					{(spinner && <Spinner {...rest} />) ||
						(loader && <DotsLoader {...rest} />) ||
						(pulse && <Pulse {...rest} />) || <Spinner {...rest} />}
					{text ? (
						<span className="text-sm text-gray-700">{t(text)}</span>
					) : null}
				</div>
			) : null}
		</div>
	)
}

const Spinner = ({ variant = "default" }) => {
	return (
		<div className={clsx(spinner[variant].wrapper)}>
			<div className={spinner[variant].loader}></div>
		</div>
	)
}

const DotsLoader = ({ variant = "default" }) => {
	return (
		<div className={clsx(dotsloader[variant].wrapper)}>
			<div
				className={`${dotsloader[variant].dots} ${dotsloader[variant].animation.firstDot}`}
			></div>
			<div
				className={`${dotsloader[variant].dots} ${dotsloader[variant].animation.secondeDot}`}
			></div>
			<div
				className={`${dotsloader[variant].dots} ${dotsloader[variant].animation.thirdDot}`}
			></div>
		</div>
	)
}

const Pulse = ({ variant = "default" }) => {
	return (
		<div className={clsx(pulse[variant].wrapper)}>
			<div className={pulse[variant].profileImage}></div>
			<div className={pulse[variant].container.wrapper}>
				<div className={pulse[variant].container.title}></div>
				<div className={pulse[variant].container.paragraph.wrapper}>
					<div className={pulse[variant].container.paragraph.line1.wrapper}>
						<div className={pulse[variant].container.paragraph.line1.grid1}></div>
						<div className={pulse[variant].container.paragraph.line1.grid2}></div>
					</div>
					<div className={pulse[variant].container.paragraph.line2}></div>
				</div>
			</div>
		</div>
	)
}
